import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { API } from "../config/api-config";
import { FileUpload } from "../service/file-upload";
import { HttpService } from "../service/http-service";

@Component({
  selector: "app-experience-task-edit",
  templateUrl: "./experience-task-edit.component.html",
  styleUrls: ["./experience-task-edit.component.css"],
})
export class ExperienceTaskEditComponent implements OnInit {
  public formData: any = {
    active: 1,
    contentEn: "",
    contentTc: "",
    // createdBy: "",
    // createdTime: "",
    detailImageEn: "",
    detailImageTc: "",
    id: 0,
    imageEn: "",
    imageTc: "",
    keyboardsNum: 0,
    ranks: 0,
    shareNum: 0,
    shareContentEn: "",
    shareContentTc: "",
    taskType: "SHARE",
    titleEn: "",
    titleTc: "",
    // updatedBy: "",
    // updatedTime: "",
    urlEn: "",
    urlTc: "",
  };

  public showImageEn = false;

  public showImageTc = false;
  public imagePath: any;

  public urlEnType = "url";

  public urlTcType = "url";

  public urlEnDisableFile = false;
  public urlTcDisableFile = false;

  constructor(
    private fileupload: FileUpload,
    private HttpService: HttpService,
    private activeRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    this.getPath();
    this.getParams();
  }

  public tempPath: string = API.getTemp;

  private getParams() {
    this.activeRoute.params.subscribe((params) => {
      console.log(params);
      if (params["id"]) {
        this.formData.id = params["id"];
        this.getDetail();
      }
    });
  }

  private getDetail() {
    this.HttpService.getData(API.experienceTask + "/" + this.formData.id).then(
      (data) => {
        if (data.status.code == 0) {
          delete data.data.createdBy;
          delete data.data.createdTime;
          delete data.data.updatedBy;
          delete data.data.updatedTime;
          this.formData = { ...this.formData, ...data.data };
          if (/^http(s):\/\//.test(data.data.urlEn)) {
            this.urlEnType = "url";
          } else {
            this.urlEnType = "file";
          }

          if (/^http(s)?:\/\//.test(data.data.urlTc)) {
            this.urlTcType = "url";
          } else {
            this.urlTcType = "file";
          }

          this.checkVideoType();
        }
      }
    );
  }

  public urlEnCanPlay = false;
  public urlTcCanPlay = false;

  private checkVideoType() {
    let reg = /(.ogg|.mp4)$/;
    if (reg.test(this.formData.urlEn)) {
      this.urlEnCanPlay = true;
    } else {
      this.urlEnCanPlay = false;
    }

    if (reg.test(this.formData.urlTc)) {
      this.urlTcCanPlay = true;
    } else {
      this.urlTcCanPlay = false;
    }
  }

  public showDetailImageEn = false;
  public showDetailImageTc = false;

  public upload(name: string, fileType: Array<string>) {
    let self = this;
    this.fileupload.upload(function (res) {
      let temRes = JSON.parse(res);
      if (temRes.status.code == 0) {
        switch (name) {
          case "imageEn":
            self.showImageEn = true;
            break;
          case "imageTc":
            self.showImageTc = true;
            break;
          case "detailImageEn":
            self.showDetailImageEn = true;
            break;
          case "detailImageTc":
            self.showDetailImageTc = true;
            break;
        }
        self.formData[name] = temRes.data.fileName;

        self.checkVideoType();
      }
    }, fileType);
  }

  private getPath(): void {
    this.HttpService.getData(API.resourcePath).then((res) => {
      this.imagePath = res.data;
      console.log(res.data);
    });
  }

  public submit() {
    let data = this.formData;
    delete data.rank;
    this.HttpService.postData(API.experienceTask, data).then((res) => {
      if (res.status.code === 0) {
        history.go(-1);
      } else {
        alert(res.status.message);
      }
    });
  }
}



// WEBPACK FOOTER //
// /Users/ken/Dev/workspace/snowmantech/naturallyplus/web-cms/src/app/experience-task-edit/experience-task-edit.component.ts